import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../table/table.css";
import { useNavigate } from "react-router-dom";
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function CustomerTable() {
  
  const navigate = useNavigate();
  var i = 0;
  const [customer, setCustomer] = useState([]);
  async function getCust() {
    await fetch("https://api.zaveromart.com/getCustomer", { mode: "cors" })
      .then((response) => response.json())
      .then((data) => {
        console.log(data[0]);
        setCustomer(data)
        // if (i === 0) {
          // setCustomer((customer) => [...customer, data]);
        // }
        // i += 1;
      });
  }

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function handleDelete(email) {
    await fetch("https://api.zaveromart.com/delCustomer", {
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "delete",
      body: JSON.stringify({
        email: email,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        alert(data.message);
        navigate("/customers");
      });
  }

  console.log(customer);
  useEffect(() => {
    getCust();
  }, []);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="tableCell">Name</TableCell>
            <TableCell className="tableCell">Email</TableCell>
            <TableCell className="tableCell">Phone</TableCell>
            <TableCell className="status"></TableCell>
            <TableCell className="status"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customer.map((row) =>(
            // row.map((entry) => (
              <TableRow key={row.email}>
                <TableCell className="tableCell" component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell className="tableCell">{row.email}</TableCell>
                <TableCell className="status">{row.phoneNo}</TableCell>
                <TableCell className="tableCell">
                  <button
                    onClick={() => {
                      navigate("/profile", {
                        state: {
                          name: row.name,
                          email: row.email,
                          phone: row.phone,
                          image: 'https://source.unsplash.com/random/?customers/'
                        },
                      });
                    }}
                    style={{
                      backgroundColor: "goldenrod",
                      border: "none",
                      borderRadius: "5px",
                      color: "white",
                      width: "80%",
                      height: "35px",
                      padding: "5px",
                      margin: "auto",
                      fontSize: "12px",
                      fontWeight: "bold",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    View Profile
                  </button>
                </TableCell>
                <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Do you confirm deletion of Customer?
                  </Typography>
                  <Box style={{marginTop:'30px'}}>
                    <Button variant="contained"
                    style={{marginRight:'30px'}}
                    onClick={() => {
                        let useremail=localStorage.getItem("deletecustomer");
                        // alert(useremail);
                        handleDelete(useremail);
                      }}
                    >Yes</Button>
                    <Button variant="contained"
                    onClick={() => {
                      handleClose()
                      }}
                    >No</Button>
                  </Box>
                  
                </Box>
                </Modal>
                <TableCell className="tableCell">
                  <button
                    onClick={() => {
                      var email = row.email;
                      localStorage.setItem("deletecustomer",email);
                      handleOpen()
                      // handleDelete(email);
                    }}
                    style={{
                      backgroundColor: "crimson",
                      border: "none",
                      borderRadius: "5px",
                      color: "white",
                      width: "80%",
                      height: "35px",
                      padding: "5px",
                      margin: "auto",
                      fontSize: "12px",
                      fontWeight: "bold",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    Delete Profile
                  </button>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
